import React from 'react'

import { corDash as cor } from '../../../utils/dashboard.js'
import { formatarMilharSemDecimais } from '../../../utils/formatarMilhar'

import CardHeader from './CardHeader'
import MyPieChart from './MyPieChart'
import TooltipGraficoPizzaSemComunicar from './TooltipGraficoPizzaSemComunicar'

export default function GraficoSimcardsSemComunicar({
  portalCliente,
  handleAbrirMenuOpcoes,
  revelarOpcoesSimcardsSemComunicar,
  menuElement,
  arraySemComunicar24h,
  tooltipSimcardsSemComunicar,
  tooltipSemComunicar24h,
  tooltipSemComunicar24h30d,
  tooltipSemComunicar30d60d,
  tooltipSemComunicar60d,
  tooltipSimcardsEmEstoque,
  totalSimcards
}) {
  return (
    <div
      className="container-dashboard-fundo-1 fundo-cor-5"
      id="grafico-simcards-sem-comunicar"
    >
      <CardHeader
        titulo="SIM cards sem comunicar"
        nomeOpcao="simcardsSemComnuicar"
        portalCliente={portalCliente}
        handleAbrirMenuOpcoes={handleAbrirMenuOpcoes}
      />
      <div className="grupo-dash-grafico-pizza-grande">
        {revelarOpcoesSimcardsSemComunicar === true && (
          <div className="menu-opcoes-dashboard-fundo">{menuElement}</div>
        )}
        <div className="container-dash-simcards-sem-comunicar">
          <div className="container-dash-grafico-pizza-sem-comunicar">
            <div className="caixa-grafico-pizza-sem-comunicar">
              <MyPieChart
                key={JSON.stringify(arraySemComunicar24h)}
                data={arraySemComunicar24h}
                valorPercentual={tooltipSimcardsSemComunicar}
                MyTooltip={(props) => (
                  <TooltipGraficoPizzaSemComunicar
                    {...props}
                    arrDados={arraySemComunicar24h}
                    totalSimcards={totalSimcards}
                    tooltipSimcardsSemComunicar={tooltipSimcardsSemComunicar}
                  />
                )}
              />
            </div>
          </div>
          <div className="container-legenda-sem-comunicar">
            <div className="linha-dash-legenda-sem-comunicar">
              <div className="coluna-legenda-sem-comunicar-1">
                <div
                  className="esfera-legenda-dashboard"
                  style={{ backgroundColor: cor.verdeClaro }}
                />
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-2">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                  Nas últimas 24 horas
                </span>
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-3">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar-numero-unico-2">
                  {formatarMilharSemDecimais(tooltipSemComunicar24h)}
                </span>
              </div>
            </div>
            <div className="linha-dash-legenda-sem-comunicar">
              <div className="coluna-legenda-sem-comunicar-1">
                <div
                  className="esfera-legenda-dashboard"
                  style={{ backgroundColor: cor.amarelo }}
                />
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-2">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                  Entre 24 h e 30 Dias
                </span>
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-3">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar-numero-unico-2">
                  {formatarMilharSemDecimais(tooltipSemComunicar24h30d)}
                </span>
              </div>
            </div>
            <div className="linha-dash-legenda-sem-comunicar">
              <div className="coluna-legenda-sem-comunicar-1">
                <div
                  className="esfera-legenda-dashboard"
                  style={{ backgroundColor: cor.laranja }}
                />
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-2">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                  Entre 30 e 60 dias
                </span>
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-3">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar-numero-unico-2">
                  {formatarMilharSemDecimais(tooltipSemComunicar30d60d)}
                </span>
              </div>
            </div>
            <div className="linha-dash-legenda-sem-comunicar">
              <div className="coluna-legenda-sem-comunicar-1">
                <div
                  className="esfera-legenda-dashboard"
                  style={{ backgroundColor: cor.vermelho }}
                />
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-2">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                  Mais de 60 dias
                </span>
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-3">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar-numero-unico-2">
                  {formatarMilharSemDecimais(tooltipSemComunicar60d)}
                </span>
              </div>
            </div>
            <div className="linha-dash-legenda-sem-comunicar">
              <div className="coluna-legenda-sem-comunicar-1">
                <div
                  className="esfera-legenda-dashboard"
                  style={{ backgroundColor: cor.azul }}
                />
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-2">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar">
                  Em estoque
                </span>
              </div>
              <div className="coluna-legenda-sc-sem-comunicar-3">
                <span className="fonte-cor-1 texto-legenda-sem-comunicar-numero-unico-2">
                  {formatarMilharSemDecimais(tooltipSimcardsEmEstoque)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
